var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgExpandIcon = function SvgExpandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.498 7.996a.466.466 0 00.35-.148L13.496 5.2l1.646 1.647a.515.515 0 00.36.149.5.5 0 00.5-.5L15.999.5a.5.5 0 00-.507-.5H9.499a.493.493 0 00-.5.5c0 .125.055.257.148.351L10.794 2.5 8.148 5.146A.467.467 0 008 5.497c0 .125.047.258.148.352l1.998 1.999a.478.478 0 00.352.148zM6.5 16a.5.5 0 00.5-.5.515.515 0 00-.148-.359l-1.647-1.648 2.646-2.647A.467.467 0 008 10.495a.479.479 0 00-.148-.352L5.854 8.144a.478.478 0 00-.352-.148.466.466 0 00-.35.148l-2.647 2.648L.86 9.144a.515.515 0 00-.36-.148.5.5 0 00-.5.5l.001 5.996c0 .282.226.508.507.508h5.994z",
    fill: "currentColor"
  })));
};
export default SvgExpandIcon;